// extracted by mini-css-extract-plugin
export var bodySections = "_59-8";
export var gray = "_59-7";
export var green = "_59-4";
export var iconContainer = "_59-9";
export var iconWidgetContainer = "_59-1";
export var phoneIcon = "_59-2";
export var red = "_59-5";
export var statusDot = "_59-3";
export var widgetContainer = "_59-0";
export var yellow = "_59-6";